import { FunctionComponent, PropsWithChildren } from 'react';

import { default as MuiBox, BoxProps } from '@mui/material/Box';

const Box: FunctionComponent<BoxProps> = (
  props: PropsWithChildren<BoxProps>
) => {
  return <MuiBox {...props}>{props.children}</MuiBox>;
};

export default Box;
